// contexts/produtos/UnMedidaContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const UnMedidaContext = createContext();

export const useUnMedida = () => useContext(UnMedidaContext);

export const UnMedidaProvider = ({ children }) => {
    const [unMedidas, setUnMedidas] = useState([]);
    const { showAlert } = useAlert(); // Access showMessage from AlertContext
    const { showMessage } = useMessage();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/UnMedida');
                setUnMedidas(result);
            } catch (error) {
                console.error("Erro ao buscar unidades de medida:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addUnMedida = async (unMedida) => {
        try {
            const result = await postData('/UnMedida', unMedida);
            const unidadeSalva = result?.sigla
                ? { ...unMedida, ...result }
                : { ...unMedida };

            setUnMedidas((unidadesAtuais) => [
                ...unidadesAtuais.filter(
                    (unidadeAtual) => unidadeAtual?.sigla
                        && unidadeAtual.sigla.toUpperCase()
                        !== unidadeSalva.sigla?.toUpperCase()
                ),
                unidadeSalva
            ]);
            showAlert('Unidade de medida cadastrada com sucesso!');
            return unidadeSalva;
        } catch (error) {
            console.error("Erro ao adicionar unidade de medida:", error);
            showMessage('Erro ao adicionar unidade de medida!\n'+error, 'danger');
            return null;
        }
    };

    const updateUnMedida = async (unMedida) => {
        try {
            const result = await putData('/UnMedida', unMedida);
            const unidadeSalva = result?.sigla
                ? { ...unMedida, ...result }
                : { ...unMedida };

            setUnMedidas((unidadesAtuais) => unidadesAtuais.map((unidadeAtual) => (
                unidadeAtual?.sigla?.toUpperCase() === unidadeSalva.sigla?.toUpperCase()
                    ? unidadeSalva
                    : unidadeAtual
            )));
            showAlert('Unidade de medida alterada com sucesso!');
            return unidadeSalva;
        } catch (error) {
            console.error("Erro ao atualizar unidade de medida:", error);
            showMessage('Erro ao atualizar unidade de medida!\n'+error, 'danger');
            return null;
        }
    };

    const deleteUnMedida = async (sigla) => {
        try {            
            await deleteData('/UnMedida', { unMedidaSigla: sigla }); // Exclusão do UnMedida no servidor
            setUnMedidas((unidadesAtuais) => unidadesAtuais.filter(u => u?.sigla !== sigla));
            showAlert('Unidade de medida excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir unidade de medida:", error);
            showMessage('Erro ao excluir unidade de medida!\n'+error, 'danger');
        }
    };

    return (
        <UnMedidaContext.Provider value={{ unMedidas, addUnMedida, updateUnMedida, deleteUnMedida }}>
            {children}
        </UnMedidaContext.Provider>
    );
};
